<template>

  <div style=" display: flex;
    flex-direction: column; justify-content: center;">

    <div class="title" style="height: 150px; display: flex;
    justify-content: center;">
      <H2>添加账号</H2>
    </div>

    <div style=" display: flex;
    justify-content: center;     height: 100px;     margin: 0px 45px;">
      <div>
        <el-form :model="form">
            <el-form-item label="功能介绍：" >
              {{ jieshao }}
            </el-form-item>
            <el-form-item label="账号" >
              <el-input v-model="form.username" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="密码" >
              <el-input v-model="form.password" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="区服（xx山xx服）" >
              <el-input v-model="form.serverName" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="福地规则" ><br/>
              <div v-for="item in form.rules">
                <el-checkbox v-model="item.isCheck" style="margin-right: 15px;"></el-checkbox>
                <el-select v-model="item.minItemLv" placeholder="请选择" style="margin-right: 15px;">
                  <el-option key="1" :label="1" :value="1"/>
                  <el-option key="2" :label="2" :value="2"/>
                  <el-option key="3" :label="3" :value="3"/>
                  <el-option key="4" :label="4" :value="4"/>
                  <el-option key="5" :label="5" :value="5"/>
                </el-select>
                {{ item.description }}
              </div>
            </el-form-item>

            <el-form-item label="顶号间隔" ><br/>
              <div>
                <el-radio-group v-model="form.topSpacing">
                  <el-radio label="1" size="large">5 分钟</el-radio>
                  <el-radio label="2" size="large">10 分钟</el-radio>
                  <el-radio label="3" size="large">15 分钟</el-radio>
                </el-radio-group>
              </div>
            </el-form-item>

          </el-form>
          <div slot="footer" style="display: flex;">
            <el-button @click="quit">返 回</el-button>
            <el-button type="primary" @click="submitAdd">确 定</el-button>
          </div>
      </div>
    </div>

  </div>

  

</template>

<script>
import axios from 'axios'
// import jsonFile from '@/assets/json/account.json';
// import qufu from '@/assets/json/qufu.json';

export default {
  name: "zh",
  data() {
    return {
      jieshao: '挂号运行时间为每日22:00至次日07:00，在此期间您可以随时顶号，脚本会在一定时间自动顶回。如果玩家在07:00之后没有进行顶号操作，当前的挂号将保持有效直至10:00，否则即刻失效，功能详情见账号管理 --- 作者微信：llnunu',
      form: {
          enabled: true,
          username: '',
          password: '',
          admin: '',
          serverName: '',
          topSpacing: '1',
          rules: [
              { "ItemId": 100004, "minItemLv": 3, "isCheck": true, "description": "仙桃" },
              { "ItemId": 100025, "minItemLv": 4, "isCheck": true, "description": "净瓶水" },
              { "ItemId": 100000, "minItemLv": 5, "isCheck": false, "description": "仙玉" },
              { "ItemId": 100003, "minItemLv": 5, "isCheck": false, "description": "灵石" },
              { "ItemId": 100029, "minItemLv": 5, "isCheck": false, "description": "琉璃珠" },
              { "ItemId": 100044, "minItemLv": 5, "isCheck": false, "description": "天衍令" },
              { "ItemId": 100047, "minItemLv": 5, "isCheck": false, "description": "昆仑铁" }
          ],
        },
    }
  },
  
  // beforeCreate() {
  //   document.querySelector('body').classList.add("overall");
  // },
  // beforeDestroy() {
  //   document.querySelector('body').classList.remove("overall");
  // },

  mounted() {

    
  },

  methods: {
  


    quit() {
      this.$router.push("/diy");
    },

    submitAdd() {

      const loading = this.$loading({
          lock: true,
          text: '录入中，请稍候...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });

      this.postRequest("xundao/addGR", this.form).then(resp => {
        console.log(resp)
        if (resp && resp.status == "200") {
          this.dialogFormVisible = false
        } else if (resp && resp.status == "500") {
          this.$confirm(resp.msg, '提示', {
                  cancelButtonText: '好的',
                  showConfirmButton: false, // 隐藏确定按钮
                  closeOnClickModal: false, // 禁用点击遮罩层关闭弹窗
                  center: true,
                  centered:true,
                  type: 'warning'
                }).then(() => { }).catch(() => { });
        }
        loading.close();
      });
    },
    
  }
}
</script>

<style>
/* 响应式样式 */
@media screen and (max-width: 768px) {
  .el-input, .el-button {
    width: 100%;
  }
}

.overall {
  position: absolute;
  content: ' ';
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  margin: 0 auto;
  height: 100%;
  width: 100%;
  background-image: url(../assets/xun.jpg);
  background-size: cover;
}

.custom-confirm {
  top: 50% !important;
  left: 50% !important;
  transform: translate(-50%, -50%) !important;
}

@media screen and (max-width:750px) {
  .el-message-box{
  width:80% !important;}}

.el-message-box__btns {
  display: flex !important;
  justify-content: center !important;
}

</style>